import Dashboard from './Dashboard'
import enhance from './Dashboard.enhancer.js'

export default enhance(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/core/Dashboard/index.js